import React from "react";
import { SITE, NAV_LINKS } from "../lib/data";

const Footer = () => {
  const handleNav = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-pw border-t border-[var(--pw-border)]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 border border-[var(--pw-gold)] flex items-center justify-center text-[var(--pw-gold)] font-serif italic text-xl">
                P
              </div>
              <div>
                <div className="font-serif text-2xl text-[var(--pw-text)]">Proscenio</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--pw-gold)]">
                  Wedding
                </div>
              </div>
            </div>
            <p className="text-[var(--pw-text)]/65 font-light text-sm leading-relaxed max-w-md">
              Music Planner per cerimonie ed eventi. Dal palcoscenico al vostro
              giorno più importante, ogni nota al posto giusto.
            </p>
            <p className="mt-4 text-[var(--pw-text)]/40 text-xs font-light">
              Parte di {SITE.parent}
            </p>
          </div>

          {/* Nav */}
          <div className="lg:col-span-3">
            <div className="overline mb-5">Navigazione</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => handleNav(l.id)}
                    className="text-[var(--pw-text)]/70 hover:text-[var(--pw-gold)] text-sm font-light transition-colors"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contatti */}
          <div className="lg:col-span-4">
            <div className="overline mb-5">Resta in contatto</div>
            <ul className="space-y-3 text-sm font-light text-[var(--pw-text)]/75">
              <li>
                <a href={`tel:${SITE.phone1.replace(/\./g, "")}`} className="hover:text-[var(--pw-gold)]">
                  {SITE.phone1}
                </a>
              </li>
              <li>
                <a href={`tel:${SITE.phone2.replace(/\./g, "")}`} className="hover:text-[var(--pw-gold)]">
                  {SITE.phone2}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="hover:text-[var(--pw-gold)] break-all">
                  {SITE.email}
                </a>
              </li>
              <li className="pt-2 leading-relaxed">{SITE.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--pw-border)] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-[var(--pw-text)]/40 font-light">
            © {new Date().getFullYear()} Proscenio Wedding. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-[var(--pw-text)]/40 font-light italic font-serif">
            "Ogni cerimonia è una scena. Noi la mettiamo in musica."
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
